import { ACTION_SET_ROUTES } from "../action";


const reduceQuery = (state = {}, action) =>{
	switch (action.type) {
		case ACTION_SET_ROUTES:{
			return {
				...state,
				[action.payload.routerId]: action.payload.routes
			}
		}
	}
	return state;
};

export default reduceQuery;